import Service from "../DepartmentService";

function GetByDepartmentAndTerm(termId, syllabusUploadStatus = 'All') {
    return Service.get('Section?termId=' + termId + '&syllabusUploadStatus=' + syllabusUploadStatus);
}


const SectionService = {
    GetByDepartmentAndTerm
};

export default SectionService;
